/* eslint-disable max-lines */
import { IBscParkingSchema } from 'shared/types/api-models/offer-card/v1/get-offer-data';

import { TCategoryExtended } from '../../../types/offerData';

export type FieldNameType =
  | 'totalArea'
  | 'livingArea'
  | 'kitchenArea'
  | 'roomArea'
  | 'landStatus'
  | 'landArea'
  | 'buildMaterialType'
  | 'buildYear'
  | 'deadline'
  | 'floorNumber'
  | 'floorsCount'
  | 'isOccupied'
  | 'classType'
  | 'ceilingHeight'
  | 'columnGrid'
  | 'garageType'
  | 'parkingType'
  | 'parkingPlacesCount'
  | 'propertyType'
  | 'commercialLandType'
  | 'minLeaseTerm'
  | 'includedAmenities'
  | 'monthlyIncome'
  | 'specialty'
  | 'decoration';

export type TFieldContent =
  | 'area'
  | 'deadline'
  | 'deadlineCompleted'
  | 'text'
  | 'floorNumber'
  | 'landStatus'
  | 'buildMaterialType'
  | 'houseLandArea'
  | 'landArea'
  | 'classType'
  | 'occupied'
  | 'commercialFloorsCount'
  | 'ceilingHeight'
  | 'commercialLandType'
  | 'commercialArea'
  | 'parkingPlacesCount'
  | 'commercialMinLeaseTerm'
  | 'coworkingAmenitiesType'
  | 'monthlyIncome'
  | 'specialties'
  | 'decoration';

export type FieldType = {
  name: FieldNameType;
  title: string;
  type: TFieldContent;
};

export type descriptionConfigType = { [index in TCategoryExtended]?: FieldType[] };

export interface IConfigOptions {
  isCommercialMultiAds: boolean;
  bscParkings: IBscParkingSchema[] | null;
}

export const totalArea = {
  name: 'totalArea' as FieldNameType,
  title: 'Общая',
  type: 'area' as TFieldContent,
};

const livingArea = {
  name: 'livingArea' as FieldNameType,
  title: 'Жилая',
  type: 'area' as TFieldContent,
};

const kitchenArea = {
  name: 'kitchenArea' as FieldNameType,
  title: 'Кухня',
  type: 'area' as TFieldContent,
};

const roomArea = {
  name: 'roomArea' as FieldNameType,
  title: 'Комната',
  type: 'area' as TFieldContent,
};

export const landStatus = {
  name: 'landStatus' as FieldNameType,
  title: 'Статус земли',
  type: 'landStatus' as TFieldContent,
};

export const landArea = {
  name: 'landArea' as FieldNameType,
  title: 'Площадь',
  type: 'landArea' as TFieldContent,
};

export const houseLandArea = {
  name: 'landArea' as FieldNameType,
  title: 'Участок',
  type: 'landArea' as TFieldContent,
};

export const buildMaterialType = {
  name: 'buildMaterialType' as FieldNameType,
  title: 'Материал дома',
  type: 'buildMaterialType' as TFieldContent,
};

export const buildYear = {
  name: 'buildYear' as FieldNameType,
  title: 'Построен',
  type: 'text' as TFieldContent,
};

export const deadlineYear = {
  name: 'deadlineYear' as FieldNameType,
  title: 'Срок сдачи',
  type: 'deadline' as TFieldContent,
};

export const deadlineCompleted = {
  name: 'deadlineYear' as FieldNameType,
  title: 'Сдан',
  type: 'deadlineCompleted' as TFieldContent,
};

export const floorNumber = {
  name: 'floorNumber' as FieldNameType,
  title: 'Этаж',
  type: 'floorNumber' as TFieldContent,
};

const floorsCount = {
  name: 'floorsCount' as FieldNameType,
  title: 'Этажей в доме',
  type: 'text' as TFieldContent,
};

const columnGrid = {
  name: 'columnGrid' as FieldNameType,
  title: 'Сетка колонн',
  type: 'text' as TFieldContent,
};

export const commercialArea = {
  name: 'totalArea' as FieldNameType,
  title: 'Площадь',
  type: 'commercialArea' as TFieldContent,
};

const commercialBuildYear = {
  name: 'buildYear' as FieldNameType,
  title: 'Год постройки',
  type: 'text' as TFieldContent,
};

export const commercialFloorsCount = {
  name: 'floorsCount' as FieldNameType,
  title: 'Этажность',
  type: 'commercialFloorsCount' as TFieldContent,
};

export const commercialCoworkingminLeaseTerm = {
  name: 'minLeaseTerm' as FieldNameType,
  title: 'Срок аренды',
  type: 'commercialMinLeaseTerm' as TFieldContent,
};

export const occupied = {
  name: 'isOccupied' as FieldNameType,
  title: 'Помещение',
  type: 'occupied' as TFieldContent,
};

export const classType = {
  name: 'classType' as FieldNameType,
  title: 'Класс',
  type: 'classType' as TFieldContent,
};

export const ceilingHeight = {
  name: 'ceilingHeight' as FieldNameType,
  title: 'Выс. потолков',
  type: 'ceilingHeight' as TFieldContent,
};

const garageType = {
  name: 'garageType' as FieldNameType,
  title: 'Тип',
  type: 'text' as TFieldContent,
};

const parkingType = {
  name: 'parkingType' as FieldNameType,
  title: 'Парковка',
  type: 'text' as TFieldContent,
};

export const commercialMultiAdsParkingType = {
  name: 'parkingPlacesCount' as FieldNameType,
  title: 'Парковка',
  type: 'parkingPlacesCount' as TFieldContent,
};

export const propertyType = {
  name: 'propertyType' as FieldNameType,
  title: 'Тип недвижимости',
  type: 'text' as TFieldContent,
};

export const commercialLandType = {
  name: 'commercialLandType' as FieldNameType,
  title: 'Категория',
  type: 'commercialLandType' as TFieldContent,
};

const coworkingAmenitiesType: FieldType = {
  name: 'includedAmenities' as FieldNameType,
  title: 'Удобства',
  type: 'coworkingAmenitiesType' as TFieldContent,
};

export const monthlyIncome: FieldType = {
  name: 'monthlyIncome',
  title: 'Прибыль',
  type: 'monthlyIncome',
};

const specialties: FieldType = {
  name: 'specialty',
  title: 'Направления',
  type: 'specialties',
};

const decoration: FieldType = {
  name: 'decoration',
  title: 'Отделка',
  type: 'decoration',
};

const houseConfig: FieldType[] = [totalArea, houseLandArea, buildMaterialType, floorsCount, buildYear];

const bedRentConfig: FieldType[] = [kitchenArea, roomArea, floorNumber, buildYear];

const roomConfig: FieldType[] = [kitchenArea, roomArea, floorNumber, buildYear];

const flatConfig: FieldType[] = [totalArea, livingArea, kitchenArea, floorNumber, buildYear];

const landSaleConfig: FieldType[] = [landArea, landStatus];

const newBuildingFlatSaleConfig: FieldType[] = [
  totalArea,
  livingArea,
  kitchenArea,
  floorNumber,
  deadlineYear,
  deadlineCompleted,
  decoration,
];

const warehouseAndIndustryConfig: FieldType[] = [commercialArea, floorNumber, columnGrid, ceilingHeight, occupied];

/**
 * Для офиса, ПСН, быт. услуг, автосервисов и общепита выводится один и тот же шаблон.
 */
export const universalCommercialInfo: FieldType[] = [commercialArea, floorNumber, occupied, classType];
const officeConfig: FieldType[] = universalCommercialInfo;
const coworkingConfig: FieldType[] = [floorNumber, commercialCoworkingminLeaseTerm, coworkingAmenitiesType];
const freeAppointmentObjectConfig: FieldType[] = universalCommercialInfo;
const carServiceConfig: FieldType[] = universalCommercialInfo;
const publicCateringConfig: FieldType[] = universalCommercialInfo;
const domesticServicesConfig: FieldType[] = universalCommercialInfo;

const shoppingAreaConfig: FieldType[] = [commercialArea, floorNumber, occupied, classType];

const buildingConfig: FieldType[] = [commercialArea, commercialFloorsCount, classType, commercialBuildYear];

const garageConfig: FieldType[] = [commercialArea, parkingType, garageType];

const businessConfigRent: FieldType[] = [commercialArea, floorNumber, propertyType];

const businessConfigSale: FieldType[] = [commercialArea, floorNumber, monthlyIncome, specialties];

const commercialLandConfig: FieldType[] = [landArea, commercialLandType];

export const descriptionConfig: descriptionConfigType = {
  bedRent: bedRentConfig,
  buildingRent: buildingConfig,
  buildingSale: buildingConfig,
  businessRent: businessConfigRent,
  businessSale: businessConfigSale,
  carServiceRent: carServiceConfig,
  carServiceSale: carServiceConfig,
  commercialLandRent: commercialLandConfig,
  commercialLandSale: commercialLandConfig,
  coworkingRent: coworkingConfig,
  cottageRent: houseConfig,
  cottageSale: houseConfig,
  dailyBedRent: bedRentConfig,
  dailyFlatRent: flatConfig,
  dailyHouseRent: houseConfig,
  dailyRoomRent: roomConfig,
  domesticServicesRent: domesticServicesConfig,
  domesticServicesSale: domesticServicesConfig,
  flatRent: flatConfig,
  flatSale: flatConfig,
  flatShareSale: flatConfig,
  freeAppointmentObjectRent: freeAppointmentObjectConfig,
  freeAppointmentObjectSale: freeAppointmentObjectConfig,
  garageRent: garageConfig,
  garageSale: garageConfig,
  houseRent: houseConfig,
  houseSale: houseConfig,
  houseShareRent: houseConfig,
  houseShareSale: houseConfig,
  industryRent: warehouseAndIndustryConfig,
  industrySale: warehouseAndIndustryConfig,
  landSale: landSaleConfig,
  newBuildingFlatSale: newBuildingFlatSaleConfig,
  officeRent: officeConfig,
  officeSale: officeConfig,
  publicCateringRent: publicCateringConfig,
  publicCateringSale: publicCateringConfig,
  roomRent: roomConfig,
  roomSale: roomConfig,
  shoppingAreaRent: shoppingAreaConfig,
  shoppingAreaSale: shoppingAreaConfig,
  townhouseRent: houseConfig,
  townhouseSale: houseConfig,
  warehouseRent: warehouseAndIndustryConfig,
  warehouseSale: warehouseAndIndustryConfig,
};
